/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Search trade request
 */
export interface SearchTradeWaysRequest {
  baseAsset: number;
  quoteAsset: number;
}
